import axios from 'axios';
axios.defaults.timeout = 10000;

const listAllBlogs = async (filter, key = '', offset) => {
  console.log('Filter: ', filter);
  const apiUrl = process.env.VUE_APP_API_URL;
  const blogs = await axios
    .get(`${apiUrl}/v1/public/blogs?filter=${filter}&q=${key}&offset=${offset}`)
    .then((response) => {
      return {
        status: response.status,
        data: response.data.data,
      };
    });
  return blogs;
};

const showBlogDetail = async (id) => {
  const apiUrl = process.env.VUE_APP_API_URL;
  const blogDetail = await axios
    .get(`${apiUrl}/v1/public/blogs/${id}`)
    .then((response) => {
      return {
        status: response.status,
        data: response.data.data,
      };
    });

  return blogDetail;
};
export default {
  listAllBlogs,
  showBlogDetail,
};
